import cl from "classnames";
import { CSSProperties } from "react";
import { useTranslation } from "react-i18next";

import cls from "./MediaPlaceholder.module.css";

import NoImageIcon from "@/shared/assets/icons/noImageIcon.svg";

interface MediaPlaceholderProps {
    className?: string;
    style?: CSSProperties;
    width?: number | string;
    height?: number | string;
    label?: string;
}

export const MediaPlaceholder = ({
    className,
    style,
    width,
    height,
    label,
}: MediaPlaceholderProps) => {
    const { t } = useTranslation();

    return (
        <span
            className={cl(cls.placeholder, className)}
            style={{ width, height, ...style }}
            role="img"
            aria-label={label || t("common.image-unavailable")}
        >
            <NoImageIcon aria-hidden="true" />
        </span>
    );
};
